import type { HeroProps } from './versions.ts'

export const DEVICES = [
  { id: 'telefon', label: 'Telefon', width: 375, height: 667, scale: 0.6 },
  { id: 'maly', label: 'Mały telefon', width: 320, height: 568, scale: 0.6 },
  { id: 'tablet', label: 'Tablet', width: 768, height: 1024, scale: 0.36 },
  { id: 'desktop', label: 'Desktop', width: 1280, height: 800, scale: 0.3 },
  { id: 'wide', label: 'Wide', width: 1440, height: 900, scale: 0.27 },
] as const

export type DeviceId = (typeof DEVICES)[number]['id']

/** Tomorrow 10:00: a believable „najbliższy wolny termin” without calling the API. */
function sampleSlot(): string {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  d.setHours(10, 0, 0, 0)
  return d.toISOString()
}

/** Landing props for the preview: buttons do nothing, so no lead, view or event is ever created. */
export function previewProps(state: 'default' | 'starting' | 'failed' = 'default'): HeroProps {
  return {
    start: () => {},
    openChat: () => {},
    starting: state === 'starting',
    startFailed: state === 'failed',
    nearest: sampleSlot(),
  }
}
